/**
 * External dependencies
 */
import { AxiosInstance, AxiosResponse } from 'axios';

/**
 * Internal dependencies
 */
import Header from '@naruto/naruto-api/src/tools/Header';
import BaseAPI from '@naruto/naruto-api/src/base';
import { BaseResponse } from './types';

class ProjectAPI extends BaseAPI {
  constructor({ axios, header }: { axios: AxiosInstance; header: Header }) {
    super({ axios, header });
  }

  /* ======== API: project ======== */
  async getProjectList<Response, Params = undefined>(params?: Params): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.get<Params, AxiosResponse<Response>>('/api/admin/projects', {
        headers: { ...this.header.header },
        params
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async getProjectInfo<Response>(projectID: string): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.get<undefined, AxiosResponse<Response>>(`/api/admin/project/${projectID}`, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async postProject<Response, Body = undefined>(body: Body): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.post<Body, AxiosResponse<Response>>('/api/admin/project', body, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async putProject<Response, Body = undefined>(projectID: string, body: Body): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.put<Body, AxiosResponse<Response>>(`/api/admin/project/${projectID}`, body, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async deleteProject<Response>(projectID: string): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.delete<Body, AxiosResponse<Response>>(`/api/admin/project/${projectID}`, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }
}

export default ProjectAPI;
